import { CapoPlugin } from "/builds/webcontact/rheinau/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];